import {AUTH_LAYOUT} from "@fndry-vue/fn-layout";
import {DEFAULT_LAYOUT} from "../../layouts";
import screens, {
    AUTH_CHECK,
    AUTH_LOGOUT,
    AUTH_LOGIN,
    AUTH_REGISTER,
    AUTH_FORGOT,
    AUTH_FORGOT_NOTIFY,
    AUTH_RESET,
    AUTH_SET_PASSWORD,
    AUTH_VERIFY
    
} from "./screens";

import {WELCOME_SCREEN} from "../welcome/screens";

import {
    makeAbilityMiddleware,
    makeAuthMiddleware,
    makeGuestMiddleware,
    makeSuperAdminMiddleware
} from "@fndry-vue/fn-auth/middleware";


const Plugin = {
    install: function(Vue, {router, layouts, middleware}){

        //register the middleware
        middleware.register("auth", makeAuthMiddleware(({to, next, auth}) => {
            next({
                name: AUTH_CHECK,
                params: {
                    redirect: to,
                    auth: true
                }
            });
        }));
        middleware.register("guest", makeGuestMiddleware(({to, next, auth}) => {
            next({
                name: WELCOME_SCREEN,
                params: {
                    redirect: to,
                    guest: true
                }
            });
        }));
        middleware.register("ability", makeAbilityMiddleware(({to, next, auth}) => {
            next("/403");
        }));
        middleware.register("superAdmin", makeSuperAdminMiddleware(({to, next, auth}) => {
            next("/403");
        }));

        //add the routes
        router.addRoutes([
            {
                path: "/auth",
                redirect: "/auth/check",
                component: layouts[AUTH_LAYOUT],
                children: [
                    {
                        path: "check",
                        name: AUTH_CHECK,
                        component: screens[AUTH_CHECK],
                        props: true
                    },
                    {
                        path: "logout",
                        name: AUTH_LOGOUT,
                        component: screens[AUTH_LOGOUT],
                        props: true
                    },
                    {
                        path: "login",
                        name: AUTH_LOGIN,
                        component: screens[AUTH_LOGIN],
                        props: true
                    },
                    {
                        path: "register",
                        name: AUTH_REGISTER,
                        component: screens[AUTH_REGISTER],
                        props: true
                    },
                    {
                        path: "verify/:token",
                        name: AUTH_VERIFY,
                        component: screens[AUTH_VERIFY],
                        props: true
                    },
                    {
                        path: "forgot",
                        name: AUTH_FORGOT,
                        component: screens[AUTH_FORGOT],
                        props: true
                    },
                    {
                        path: "forgot/notify",
                        name: AUTH_FORGOT_NOTIFY,
                        component: screens[AUTH_FORGOT_NOTIFY],
                        props: true
                    },
                    {
                        path: "reset",
                        name: AUTH_RESET,
                        component: screens[AUTH_RESET],
                        props: true
                    },
                    {
                        path: "set-password",
                        name: AUTH_SET_PASSWORD,
                        component: screens[AUTH_SET_PASSWORD],
                        props: true
                    },
                ]
            }
        ]);

        // //add the messages
        // locale.addLocales({
        //     en: en
        // });


    },
    init: function(App){
        App.$fnMenus.addItems("main", [
            {
                to: {name: AUTH_LOGOUT},
                text: App.$t("Log Out")
            }
        ]);
    }
};

export default Plugin;
